import request from '@/utils/request';
export function reminderList(data) {
  return request.post('admin/insurance-reminder/list', data);
}
export function addReminder(data) {
  return request.post('admin/insurance-reminder/store', data);
}
export function editReminder(data) {
  return request.post('admin/insurance-reminder/edit', data);
}
export function reminderStatus(data) {
  return request.post('admin/insurance-reminder/status', data);
}
export function delReminder(data) {
  return request.post('admin/insurance-reminder/delete', data);
}
export function reminderDetail(data) {
  return request.post('admin/insurance-reminder/detail', data);
}
export function reminderResource(data) {
  return request.post('admin/insurance-reminder/resource', data);
}